import { DateOnly } from './date-only';

export class MonthOnly {
  year = 0;
  month = 0;

  /**
   * Creates a new object representing a month for a given year.
   *
   * @param year Integer value representing the year.
   * @param month Integer value representing the month, beginning with 0 for January to 11 for December. If a value less than 0 or greater than 11 is passed in, then those months will be substracted/added to the date.
   */
  constructor(year: number, month: number) {
    const date = new Date(year, month, 1);
    this.year = date.getFullYear();
    this.month = date.getMonth();
  }

  /**
   * Returns a Date object with day set to 1 and time set to 00:00:00.
   */
  toDate() {
    return new Date(this.year, this.month);
  }

  /**
   * Returns a MonthOnly object given a DateOnly object.
   *
   * @param date Date object.
   */
  static fromDateOnly(date: DateOnly) {
    return new MonthOnly(date.year, date.month);
  }

  /**
   * Returns a MonthOnly object given a Date object.
   *
   * @param date Date object.
   */
  static fromDate(date: Date) {
    return new MonthOnly(date.getFullYear(), date.getMonth());
  }
}
